<template lang="html">
  <header id="header">
    <div class="header-content">

      <section class="top-section">
        <div class="container med-container">
          <div class="row">
            <!-- <div class="col-lg col-form">
              <b-form @submit="onSubmit">
                <b-form-input
                  v-model="form.keywords"
                  type="text"
                  placeholder="SEARCH IN OUR KNOWLEDGE CENTER..."
                  size="sm"
                  required
                ></b-form-input>
                <b-button type="submit" size="sm"><i class="fas fa-search"></i></b-button>
              </b-form>
            </div> -->

            <div class="col-lg col-buttons">
              <span class="d-none d-sm-inline-block"><i class="fa-light fa-envelope"></i> Email: <a href="mailto:info@quinceanerashopping.com">info@quinceanerashopping.com</a></span>
              <span class="d-none d-sm-inline-block ml-4"><i class="fa-brands fa-whatsapp"></i> WhatsApp: <a href="tel:2144147613">21 4414 7613</a></span>
              <!-- <a class="d-none d-sm-inline-block whatsapp ml-4" target="_blank" href="https://wa.me/3320660745"><i class="icon"></i> ATENCIÓN AL CLIENTE</a> -->
              <!-- <router-link class="d-none d-sm-inline-block" to="/cart"><i class="fa-solid fa-cart-shopping"></i> CARRITO</router-link> -->
              <!-- <router-link class="ml-lg-4 t-150 btn-special d-none d-lg-inline" to="/cart"><i class="fa-solid fa-cart-shopping icon"></i> CARRITO</router-link> -->
            </div>

            <!-- <div class="col-lg col-social-networks">
              <a class="btn-network" href="#"><i class="fab fa-google-play"></i></a>
              <a class="btn-network" href="#"><i class="fab fa-apple"></i></a>
            </div> -->
          </div>
        </div>
      </section>

      <section class="menu-section">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <div class="container med-container">
            <b-navbar-brand to="/">
              <img src="public/images/logo.png" alt="XV Shopping">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse">
              <i class="fa-sharp fa-regular fa-bars"></i>
            </b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown class="courses-dropdown" left>
                  <template #button-content>
                    <router-link :to="'/productos'">Catálogo</router-link>
                  </template>
                  <b-dropdown-item :to="'/producto/'+c.id" v-for="(c, cInx) in categories" :key="'cInx-'+cInx">{{ c.name }}</b-dropdown-item>
                </b-nav-item-dropdown> -->

                <b-nav-item class="simple-item" to="/">Inicio</b-nav-item>
                <li class="nav-item item-simple">
                  <a class="nav-link" @click="isHActive = !isHActive">Catálogo <i class="fas fa-chevron-down submenu-icon"></i></a>
                </li>
                <!-- <b-nav-item class="simple-item" to="">Servicios</b-nav-item> -->
                <!-- <b-nav-item class="simple-item" to="/sets">Sets</b-nav-item> -->
                <b-nav-item-dropdown right>
                  <template #button-content>
                    <span>Sets</span>
                  </template>
                  <b-dropdown-item to="/sets">Todos los sets</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para XV Años</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para 16 Años</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para Bodas</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para Bautizo</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para Confirmación</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para 25 Aniversario</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para 50 Aniversario</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para Comunión</b-dropdown-item>
                  <b-dropdown-item to="/sets">Para Presentaciones</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item class="simple-item" to="/nosotros">Nosotros</b-nav-item>
                <b-nav-item class="simple-item" to="/blog">Blog</b-nav-item>
                <!-- <b-nav-item class="simple-item" to="/contacto">Contacto</b-nav-item> -->

                <b-nav-item class="icon-item" to="/contacto">
                  <i class="fas fa-envelope icon"></i> <span class="d-lg-none">Contacto</span>
                </b-nav-item>

                <b-nav-item class="icon-item" to="/cart">
                  <i class="fa-solid fa-cart-shopping icon"></i> <span class="d-lg-none">Carrito</span>
                </b-nav-item>

                <b-nav-item-dropdown class="icon-item" right>
                  <template #button-content>
                    <span>
                      <i class="fas fa-user-circle icon"></i> <span class="d-lg-none">Mi cuenta</span>
                  </span>
                  </template>
                  <b-dropdown-item to="/login">Iniciar sesión</b-dropdown-item>
                  <b-dropdown-item to="/registrarse">Registrarse</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
          </div>
        </b-navbar>
      </section>

      <section class="bottom-section">
        <div class="container med-container">
          <div class="row">
            <div class="col-lg-9 col-form">

              <b-nav-form class="search-form" @submit="onSubmitSearch">
                <label for="i-keywords">Buscar productos:</label>

                <div class="form-results-containter">
                  <b-form-input placeholder="Por nombre o sku" v-model="formSearch.keywords" required></b-form-input>

                  <!-- <b-form-select v-model="formSearch.category" >
                    <b-form-select-option :value="null">Categorías</b-form-select-option>
                    <b-form-select-option v-for="(cat,indx) in categories" :key="indx" :value="cat.id">{{cat.name}}</b-form-select-option>
                  </b-form-select> -->

                  <b-button class="btn-search" type="submit"><span class="d-none d-sm-inline">Buscar</span><i class="fas fa-search d-sm-none"></i></b-button>
                  <!-- Autocomplete -->
                  <div class="bg-autocomplete" v-bind:class="{ active: isAutocompActive }" @click="isAutocompActive = false;"></div>
                  <div class="box-autocomplete" v-bind:class="{ active: isAutocompActive }">
                    <div class="box">
                      <div class="box-results">

                        <div class="d-block text-center">
                          <!-- <loading2 v-if="isAuComLoading"></loading2> -->
                        </div>

                        <router-link class="flex-center-xy row-product"
                          :to="'/producto/'+$root._converToURL(p.name, p.id)"
                          v-for="(p, rInx) in autocompProds"
                          v-if="autocompProds.length > 0"
                          :key="'rInx-'+rInx">
                          <div class="col img" v-bind:style="{ backgroundImage: 'url('+p.image+')' }"></div>
                          <div class="col txt">
                            <!-- <div class="bubble-discount">-20%</div> -->
                            <h6 class="mini-text">{{ getCategoryName(p.categories_id) }}</h6>
                            <h6 class="name">{{ p.name }}</h6>
                            <h6 class="price">
                              <!-- Ver más -->
                              <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.price) }}</span>
                              <!-- <span class="p-discount">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.priceOld) }}</span> -->
                            </h6>
                          </div>
                        </router-link>

                        <router-link class="flex-center-xy trans-150 row-product all t-150" v-if="autocompProds.length > 0" :to="{ path: '/busqueda', query: {keywords:this.formSearch.keywords} }">
                          <div class="col txt text-center">Mostrar todos</div>
                        </router-link>

                        <a class="flex-center-xy row-product no-shad" v-if="autocompProds.length <= 0 && !isAuComLoading">
                          <div class="col txt text-center">Sin resultados</div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!--  -->
                </div>
              </b-nav-form>
            </div>

            <!-- <div class="col-lg-3 col-text">
              <a class="link-pdf" download target="_blank" href=""><i class="icon"></i> DESCARGAR CATÁLOGO</a>
              <router-link class="ml-3 link" to="/vectores">VECTORES</router-link>
            </div> -->
          </div>
        </div>
      </section>
    </div>

    <!-- Productos -->
    <div class="t-250 products-menu" v-bind:class="{ active: isHActive }">
      <div class="menu-bg" @click="isHActive = false"></div>

      <div class="tablist" role="tablist">
        <div class="t-250 box-title" @click="isHActive = false">
          <h4>CATÁLOGO</h4>
          <!-- <br>
          <h5 v-on:click="$router.push('/categoria');">Categorias</h5> -->
          <!-- <i class="fas fa-chevron-left icon"></i> -->
          <i class="fas fa-chevron-square-left icon"></i>
        </div>

        <b-card no-body class="mb-1" v-for="(category, pcatIndex) in $root.categories" :key="pcatIndex">
          <b-card-header header-tag="header" role="tab">
            <div v-if="category.subcategories" class="btn-toggle">
              <router-link :to="'/categoria/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
              <span class="fake-toggle" v-b-toggle="'accordion-'+pcatIndex"></span>
            </div>
            <router-link v-else class="btn-toggle" :to="'/productos/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
          </b-card-header>

          <b-collapse v-if="category.subcategories" :id="'accordion-'+pcatIndex" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="ul-sub-options">
                <li v-for="subcategory in category.subcategories">
                  <router-link class="t-250" :to="'/subcategoria/'+$root._converToURL(subcategory.name, subcategory.id)">{{ subcategory.name }}</router-link>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <!--  -->

  </header>
</template>

<script>
export default {
  data() {
    return {
      isAutocompActive: false,
      isAuComLoading: true,
      autocompProds: [
        // { id: 1, img: 'public/images/pages/products/product-4.jpg', brand: "Quinceañera", price: "90.00", name: 'Ramo de rosas y flor c/broches baby blue con oro' },
        // { id: 2, img: 'public/images/pages/products/product-1.jpg', brand: "Quinceañera", price: "75.00", name: 'Corona T-358 plata' },
        // { id: 3, img: 'public/images/pages/products/product-5.jpg', brand: "Quinceañera", price: "52.20", name: 'Corona flor piedra oval rose gold T-190' },
      ],

      // == Products menu ==
      isHActive: false,
      categories:[ // ** Remover el contenido de este array ejemplo al conectar para no dejar CODIGO BASURA
        // { id: 2, name: 'Ejemplo de categoría', subcategories: [
        //   { id: 1, name: 'Ejemplo de subcategoría' },
        //   { id: 2, name: 'Ejemplo de subcategoría' },
        // ] },
        // { id: 4, name: 'Ejemplo de categoría', subcategories: [
        //   { id: 1, name: 'Ejemplo de subcategoría' },
        //   { id: 2, name: 'Ejemplo de subcategoría' },
        // ]},
        // { id: 1, name: 'Accesorios' },
        // { id: 2, name: 'Baby Shower' },
        // { id: 3, name: 'Bautizo' },
        // { id: 4, name: 'Boda' },
        // { id: 5, name: 'Broches' },
        // { id: 6, name: 'Cadete' },
        // { id: 7, name: 'Comunion' },
        // { id: 8, name: 'Confirmacion' },
        // { id: 9, name: 'Fiestas' },
        // { id: 1, name: 'Fiestas Mexicanas' },
        // { id: 2, name: 'Graduacion' },
        // { id: 3, name: 'Imagenes Religiosas' },
        // { id: 4, name: 'Presentacion' },
        // { id: 5, name: 'Quinceañera' },
        // { id: 3, name: 'Religioso' },
        // { id: 7, name: 'Rosarios' },
      ],
      // == ==

      formCatalog: {
        cat: [],
      },

      formSearch: {
        keywords: null,
        category: null,
      }
    }
  },

  methods: {
    onSubmitSearch(event) {
      event.preventDefault();

      console.log(this.formSearch.keywords.trim().length);
      if(this.formSearch.keywords.trim().length >= 3) {
        this.$router.push({ path: '/busqueda', query: {keywords:this.formSearch.keywords }});

        setTimeout(()=> this.formSearch.keywords = null, 150)
      }else {
        alert('Escriba al menos 3 caracteres');
      }
    },

    onSubmitCatalog(event) {
      event.preventDefault();
    },

    getCategoryName(cat_id) {
      let gato = {};
      gato = this.$root.categories.find(x => x.id === cat_id);
      if(typeof gato !== 'object') {
        gato = { name: null };
      }

      return gato.name;
    }
  },

  watch: {
    $route (to, from){
      // Ocultar menu cada vez que cambie la ruta
      this.isAutocompActive = false;
      this.autocompProds = [];
      this.formSearch.keywords = null;

      // Ocultar menu cada vez que cambie la ruta
      this.isHActive = false;
    },

    'formSearch.keywords' (val, oldVal){
      this.autocompProds = [];

      if(val.length >= 3){ // Buscar solo si tiene al menos 3 letras
        this.isAutocompActive = false;

        axios.post(tools.url('/api/products/search'),this.formSearch).then((response) =>{
          this.autocompProds = response.data;
          this.isAutocompActive = (this.autocompProds.length) ? true : false;
        }).catch((error)=>{
          console.log(error);
        });
      } else {
        this.isAutocompActive = false;
      }
    }
  },
}
</script>
